import { useEffect, useState } from "react";
import { buildGlobalStylesComponent } from "../globalStyles";
import { getCustomizationLocalStorage } from "services/customizationService";
import { LS_CUSTOMIZATION_SET_EVENT_KEY } from "constants/constants";
import i18n from "i18next";

const GlobalStylesWrapper = () => {
    const [currentTheme, setCurrentTheme] = useState<string | null>(
        getCustomizationLocalStorage(),
    );

    const textDirection = i18n.dir(i18n.language);
    const rtlNotistackOverrides = `
        .notistack-MuiContent {
            display: block;
        }
        
        .notistack-MuiContent #notistack-snackbar {
            text-align: end;
            display: block;
            margin-right: 1.5rem;
        }
    `;
    const notistackOverrides =
        "rtl" === textDirection ? rtlNotistackOverrides : null;

    useEffect(() => {
        // Also listened without a subdomain: SubdomainHandler clears the stored customization there.
        // A cleared customization (null) brings the default theme back.
        const handleCustomizationSet = () => {
            setCurrentTheme(getCustomizationLocalStorage());
        };

        window.addEventListener(
            LS_CUSTOMIZATION_SET_EVENT_KEY,
            handleCustomizationSet,
        );

        return () => {
            window.removeEventListener(
                LS_CUSTOMIZATION_SET_EVENT_KEY,
                handleCustomizationSet,
            );
        };
    }, []);

    const GlobalStyle = buildGlobalStylesComponent({
        overrides: currentTheme,
        notistackOverrides,
    });

    return <GlobalStyle />;
};

export default GlobalStylesWrapper;
